






























































































































































import Vue from 'vue'
import ConfirmSimple from '@/components/ConfirmSimple.vue'
import ExpandableCheckbox from '@/components/ExpandableCheckbox.vue'

export default Vue.extend({
  name: 'UserSettings',

  components: {
    ConfirmSimple,
    ExpandableCheckbox,
  },

  props: {
    value: {},
    saveChangesLoading: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    value: {
      handler: function () {
        this.isFormTouched = JSON.stringify(this.value) !== this.touchCompareObject;
      },
      deep: true,
    }
  },

  async mounted() {
    const promises = [
      this.$api
        .get('/articles/slug/user-settings-consent-short')
        .then((result) => (this.consentShort = result.data.content)),
      this.$api
        .get('/articles/slug/user-settings-consent-long')
        .then((result) => (this.consentLong = result.data.content)),
    ]

    Promise.all(promises).then(() => (this.contentLoaded = true))
  },

  data: function () {
    return {
      consentShort: '',
      consentLong: '',
      contentLoaded: false,
      privacyPolicy: false,
      userSettingsFormIsValid: false,
      removeMyAccountConfirm: false,
      touchCompareObject: JSON.stringify(this.value),
      isFormTouched: false,
      firstnameRules: [(v: string) => !!v || 'First name is required.'],
      lastnameRules: [(v: string) => !!v || 'Last name is required.'],
      countryRules: [(v: string) => !!v || 'Country is required.'],
      nicknameRules: [
        (v: string) => !!v || 'Nickname is required.',
        (v: string) =>
          v.match(/^[a-z0-9.]+$/) !== null ||
          'Use only small letters, digits and dots.',
      ],
      passwordRules: [
        (v: string) =>
          !v ||
          v.length === 0 ||
          v.length >= 8 ||
          'Password must be at least 8 characters long.',
      ],
      facebookUrlRules: [
        (v: string) =>
          v.length === 0 ||
          v.startsWith('https://facebook.com') ||
          'Facebook link must start with https://facebook.com',
      ],
      instagramUrlRules: [
        (v: string) =>
          v.length === 0 ||
          v.startsWith('https://instagram.com') ||
          'Instagram link must start with https://instagram.com',
      ],
      twitterUrlRules: [
        (v: string) =>
          v.length === 0 ||
          v.startsWith('https://twitter.com') ||
          'Instagram link must start with https://twitter.com',
      ],
      privacyPolicyRules: [
        (v: boolean) => !!v || 'You have to confirm this consent.',
      ],
    }
  },

  methods: {
    saveChanges: function () {
      (this.$refs.userSettingsFormRef as any).validate()
      if (!this.userSettingsFormIsValid) {
        this.$store.dispatch(
          'alert/error',
          'There are some problems with the form.'
        )
        return
      }
      this.$emit('saveChangesClicked')
      this.privacyPolicy = false
      ;(this.$refs.userSettingsFormRef as any).resetValidation()
    },
  },
})
